export default "__VITE_ASSET__f942acc0__"